import React from "react";
import { AiFillGithub, AiFillLinkedin, AiOutlineTwitter } from "react-icons/ai";
import logo from "../../assets/icons/logo.png";
import dev from "../../assets/icons/dev.png";

const Footer = () => {
  return (
    <div>
      <footer class=" bg-black ">
        <div class="container p-6 mx-auto">
          <div class="lg:flex">
            <div class="w-full -mx-6 lg:w-2/5">
              <div class="px-6">
                <div className="flex items-center">
                  <a
                    href="/"
                    className="md:flex hidden items-center space-x-2 md:space-x-10"
                  >
                    <img className="h-30 w-40" src={logo} />
                  </a>
                </div>

              <a href="https://twitter.com/novumwellness?lang=en" target="_">
                <div class="flex ml-[3rem]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="20"
                    height="20"
                    viewBox="0 0 48 48"
                  >
                    <polygon
                      fill="#fff"
                      points="41,6 9.929,42 6.215,42 37.287,6"
                    ></polygon>
                    <polygon
                      fill=""
                      fill-rule="evenodd"
                      points="31.143,41 7.82,7 16.777,7 40.1,41"
                      clip-rule="evenodd"
                    ></polygon>
                    <path
                      fill="#fff"
                      d="M15.724,9l20.578,30h-4.106L11.618,9H15.724 M17.304,6H5.922l24.694,36h11.382L17.304,6L17.304,6z"
                    ></path>
                  </svg>

                  <a
                    href="https://web.facebook.com/Novumwellnesscenter/?_rdc=1&_rdr"
                    target="blank"
                    class="mx-2 text-white transition-colors duration-300 :text-gray-300 hover:text-blue-500 :hover:text-blue-400"
                    aria-label="Facebook"
                  >
                    <svg
                      class="w-5 h-5 fill-current"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M2.00195 12.002C2.00312 16.9214 5.58036 21.1101 10.439 21.881V14.892H7.90195V12.002H10.442V9.80204C10.3284 8.75958 10.6845 7.72064 11.4136 6.96698C12.1427 6.21332 13.1693 5.82306 14.215 5.90204C14.9655 5.91417 15.7141 5.98101 16.455 6.10205V8.56104H15.191C14.7558 8.50405 14.3183 8.64777 14.0017 8.95171C13.6851 9.25566 13.5237 9.68693 13.563 10.124V12.002H16.334L15.891 14.893H13.563V21.881C18.8174 21.0506 22.502 16.2518 21.9475 10.9611C21.3929 5.67041 16.7932 1.73997 11.4808 2.01722C6.16831 2.29447 2.0028 6.68235 2.00195 12.002Z"></path>
                    </svg>
                  </a>
                </div>
                </a>
                
              </div>
            </div>

    <div>
        <p className="text-white text-[25px]">Operating Hours</p>
            <div className="grid grid-cols-3 gap-x-8 gap-y-2 mt-4">
            <div className="flex text-white gap-x-4">
              <p className="">Monday</p>
              <p>9:00 am - 6:00 pm</p>
            </div>

            <div className="flex text-white gap-x-4">
              <p className="">Tuesday</p>
              <p>9:00 am - 6:00 pm</p>
            </div>

            <div className="flex text-white gap-x-4">
              <p className="">Wednesday</p>
              <p>9:00 am - 6:00 pm</p>
            </div>

            <div className="flex text-white gap-x-4">
              <p className="">Thursday</p>
              <p>9:00 am - 6:00 pm</p>
            </div>

            <div className="flex text-white gap-x-4">
              <p className="">Friday</p>
              <p>9:00 am - 6:00 pm</p>
            </div>

            <div className="flex text-white gap-x-4">
              <p className="">Saturday</p>
              <p>Closed</p>
            </div>

            <div className="flex text-white gap-x-4">
              <p className="">Sunday</p>
              <p>Closed</p>
            </div>
            </div>
    </div>
          </div>

          <div className="mt-8">
            <p class="text-center text-gray-500 :text-gray-400">
              © Brand 2023 | Designed by Applistructure 
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
